import { render } from "./productScoringModal.vue?vue&type=template&id=64a475ba&scoped=true&ts=true"
import script from "./productScoringModal.vue?vue&type=script&lang=ts"
export * from "./productScoringModal.vue?vue&type=script&lang=ts"

import "./productScoringModal.vue?vue&type=style&index=0&id=64a475ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a475ba"]])

export default __exports__